import { AxiosInstance } from 'axios';

export const getDownloadServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => {
  return {
    getDownloadUrls() {
      return GateWayInstance.get<{
        portal_url: string;
        client_url: string;
        cloud_game_url: string;
        android_url: string;
        ios_url: string;
        demo_aid: string;
      }>(`/urls`);
    },
  };
};
